<template>
  <div class="row mt-2 mb-3">
    <div class="col-5 order-setupitem-title-area">
      <h4>{{title}}</h4>
      <div class="order-setupitem-details">
        
      </div>
    </div>
    <div class="col-6">
      <template v-if="isStatusPending">
        <div v-if="userHasCreatePermission(PermissionTypes.OrderPermissionTypes.order) && !isOrderOnHold && canActionItem">
          <ProgressTrackerButton @click="$emit('complete')" :icon="actionIcon">{{actionTitle}}</ProgressTrackerButton>
          &nbsp;&nbsp;
          <ProgressTrackerButton v-if="secondaryActionTitle" @click="$emit('completeSecondary')" :icon="secondaryActionIcon">{{secondaryActionTitle}}</ProgressTrackerButton>
          <span v-if="secondaryActionTitle">&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <ProgressTrackerButton @click="$emit('skip')" icon="fa-fast-forward" v-if="userHasCreatePermission(PermissionTypes.OrderPermissionTypes.order)">Skip</ProgressTrackerButton>
        </div>
        <div class="mt-1" v-if="(!userHasCreatePermission(PermissionTypes.OrderPermissionTypes.order) || isOrderOnHold)">
          <p v-if="isOrderOnHold">Order on hold. Resume order before confirming items</p>
          <p v-if="!isOrderOnHold" class="font-weight-bold">Order create permission required</p>
        </div>
        <slot name="pending" />
      </template>
      <div v-if="isStatusCompleted">
        <p class="order-setupitem-result status-approved"><i class="far fa-check-circle"></i> Completed</p>
        <div class="order-setupitem-notes" v-if="historyLog.length > 0">
          <div v-for="(history, index) of historyLog" :key="index">
            {{history.status | formatLookupName(OrderChecklistStatusTypeLookup)}} by {{history.userName}} at {{history.dateActioned | formatDateTime}}
            <template v-if="history.status == OrderChecklistStatusTypes.skipped">
              with reason <span v-html="convertNewlinesToBreaks(history.skipReason)" />
            </template>
          </div>
        </div>
        <slot name="completed" />
      </div>
      <div v-if="isStatusSkipped">
        <p class="order-setupitem-result status-warning"><i class="far fa-arrow-circle-right"></i> Skipped</p>
        <div class="order-setupitem-notes" v-if="historyLog.length > 0">
          <div v-for="(history, index) of historyLog" :key="index">
            {{history.status | formatLookupName(OrderChecklistStatusTypeLookup)}} by {{history.userName}} at {{history.dateActioned | formatDateTime}}
            <template v-if="history.status == OrderChecklistStatusTypes.skipped">
              with reason <span v-html="convertNewlinesToBreaks(history.skipReason)" />
            </template>
          </div>
        </div>        
        <slot name="skipped" />
      </div>
    </div>
    <div class="col-1">
    </div>
  </div>
</template>


<script>
import _ from 'lodash'
import ProgressTrackerButton from '@/components/layout/progressTrackerButton.vue'
import { OrderStatusTypes, OrderChecklistItemTypes, OrderChecklistStatusTypes, OrderChecklistStatusTypeLookup } from '@/store/types'

export default {
  name: 'OrderChecklistItem',
  components: {
    ProgressTrackerButton
  },
  props: {
    order: Object,
    title: String,
    type: String,
    description: String,
    actionTitle: String,
    actionIcon: String,
    secondaryActionTitle: String,
    secondaryActionIcon: String
  },
  computed: {
    canActionItem() {
      if(!this.order)
        return false
      return this.order.status == OrderStatusTypes.preProduction
    },
    checklistItem() {
      if(!this.order || !this.order.orderChecklistItems)
        return null
      return this.order.orderChecklistItems.find(item => item.type == this.type)
    },
    isStatusPending() {
      let item = this.checklistItem
      if(item && item.status != OrderChecklistStatusTypes.pending)
        return false
      return true
    },
    isStatusCompleted() {
      let item = this.checklistItem
      if(item && item.status == OrderChecklistStatusTypes.completed)
        return true
      return false
    },
    isStatusSkipped() {
      let item = this.checklistItem
      if(item && item.status == OrderChecklistStatusTypes.skipped)
        return true
      return false
    },
    isOrderOnHold() {
      return this.order.isOnHold
    },
    userName() {
      return this.checklistItem.user ? this.checklistItem.user.name : ''
    },
    dateActioned() {
      return this.checklistItem.dateActioned
    },
    historyLog() {
      var log = _.clone(this.checklistItem.historyLog || [])

      if(this.isStatusSkipped || this.isStatusCompleted)
        log.splice(0, 0, { status: this.checklistItem.status, userName: this.userName, dateActioned: this.checklistItem.dateActioned, skipReason: this.checklistItem.skipReason })

      return log
    },
  },
  created() {
    this.OrderChecklistItemTypes = OrderChecklistItemTypes
    this.OrderChecklistStatusTypes = OrderChecklistStatusTypes
    this.OrderChecklistStatusTypeLookup = OrderChecklistStatusTypeLookup
  }
}
</script>